import React from "react";
import Layout from "../components/Layout";
import Map from "../components/Map";
import Sponsors from "../components/Sponsors";

const Location = () => {
  return (
    <Layout>
      <div class="slider-area">
        <div class="single-slider hero-overly slider-height2 slider-bg2 d-flex align-items-center">
          <div class="container">
            <div class="row justify-content-center ">
              <div class="col-xxl-12">
                <div class="hero-caption hero-caption2">
                  <h2>Location</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Location;
